export class FlipCard {
  constructor (elem) {
    this.inner = elem.querySelector('[data-flip-card-inner]')
    this.front = elem.querySelector('[data-flip-card-front]')
    this.back = elem.querySelector('[data-flip-card-back]')
    this.toggle = elem.querySelectorAll('[data-flip-card-toggle]')

    if (this.toggle === null) {
      return
    }

    // loop over this.toggle and add event listeners
    this.toggle.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        this.flip()
      })
    })
  }

  flip () {
    this.inner.classList.toggle('flip-card--flipped')
    if (this.inner.classList.contains('flip-card--flipped')) {
      this.front.setAttribute('aria-hidden', 'true')
      this.back.setAttribute('aria-hidden', 'false')
    } else {
      this.front.setAttribute('aria-hidden', 'false')
      this.back.setAttribute('aria-hidden', 'true')
    }
  }
}

export function setupFlipCards (document) {
  const elems = document.querySelectorAll('[data-flip-card]')
  const flipCards = []

  for (const element of elems) {
    flipCards.push(new FlipCard(element))
  }

  return flipCards
}
